import React from 'react';

import Table from 'components/common/Table';

import { adminWarehouseApi } from 'api';

import { ADMIN_WAREHOUSE_LIST_COLUMNS } from 'constants/admin/warehouse';

const Warehouse = () => {
  return (
    <Table
      title="Warehouse"
      apiService={adminWarehouseApi}
      columns={ADMIN_WAREHOUSE_LIST_COLUMNS}
    />
  );
};

export default Warehouse;
